<nph-layout>
    <ng-template #logo>
        <app-main-template-logo />
    </ng-template>

    <ng-template #topbar>
        <app-main-template-topbar />
    </ng-template>

    <ng-template #profileSidebar>
        <app-main-template-profile-sidebar />
    </ng-template>
</nph-layout>